import React from 'react';

import { makeStyles } from '@mui/styles';
import {
  DatePicker as MuiDatePicker,
  DatePickerProps as MuiDatePickerProps,
} from '@mui/x-date-pickers/DatePicker';

import TextField, {
  TextFieldProps as BaseTextFieldProps,
} from '@libs/ui/components/form/text-field';

export interface DatePickerProps extends Omit<
  MuiDatePickerProps,
  'slots' | 'slotProps' | 'renderInput'
> {
  TextFieldProps?: BaseTextFieldProps;
  /** @deprecated Use `format` instead */
  inputFormat?: string;
}

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiDialogActions-root button': {
      color: theme.palette.secondary.main,
    },
  },
}));

const DatePicker = (props: DatePickerProps) => {
  const { TextFieldProps, inputFormat, ...rest } = props;
  const classes = useStyles();

  return (
    <MuiDatePicker
      {...rest}
      enableAccessibleFieldDOMStructure={false}
      format={rest.format || inputFormat}
      slots={{
        textField: TextField,
      }}
      slotProps={{
        textField: {
          fullWidth: true,
          ...(TextFieldProps as any),
        },
        openPickerButton: { color: 'secondary' as const },
        desktopPaper: { classes: { root: classes.root } },
        mobilePaper: { classes: { root: classes.root } },
      }}
    />
  );
};

export default DatePicker;
